module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "OKBLogo.8b0e77b3.png";